/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-14 11:22:05
 * @LastEditTime: 2021-05-15 21:25:07
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import Router from 'vue-router'
// import { getUserInfo, authAddUserInfo, addUserInfo } from './../server/account/account'
import storage from 'storejs'
import storageByCode from "../utils/storageByCode";
import store from './../store'
import { getUrlParam } from './../utils/common'
import encode from './../server/api/encode'
import { versionDiff } from './../utils/versionDiff'
import { checkSession } from './../server/user/user'

import sa from 'sa-sdk-javascript'

Vue.use(Router)

//  类型为2
function YXGJRouter () {
  const router = [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/home/index'),
      meta: {
        title: '医学工具',
        buriedTitle: '医学工具',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        },
        showRightBtn: true,
        rightBtnTxt: '收藏'
      }
    },
    {
      path: '/formulaDetail',
      name: 'formulaDetail',
      component: () => import('@/pages/medicalFormula/formulaDetail'),
      meta: {
        title: '医学公式',
        buriedTitle: '医学公式-详情页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
        // showRightBtn: true,
        // rightBtnTxt: '收藏'
      }
    },
    {
      path: '/formulaHome',
      name: 'formulaHome',
      component: () => import('@/pages/medicalFormula/formulaHome'),
      meta: {
        title: '医学公式',
        buriedTitle: '医学公式-首页',
        titleColor: {// 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        },
        showRightBtn: true,
        rightBtnTxt: '收藏'
      }
    },
    {
      path: '/formulaSearch',
      name: 'formulaSearch',
      component: () => import('@/pages/medicalFormula/formulaSearch'),
      meta: {
        title: '医学公式',
        buriedTitle: '医学公式-搜索页',
        titleColor: {// 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/drugAndFoodTabooList',
      name: 'drugAndFoodTabooList',
      component: () => import('@/pages/medicaAssistant/drugAndFoodTaboo/drugAndFoodTabooList'),
      meta: {
        title: '药食禁忌',
        buriedTitle: '药食禁忌-首页',
        titleColor: {// 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/drugAndFoodTabooSearch',
      name: 'drugAndFoodTabooSearch',
      component: () => import('@/pages/medicaAssistant/drugAndFoodTaboo/drugAndFoodTabooSearch'),
      meta: {
        title: '药食禁忌-搜索结果',
        buriedTitle: '药食禁忌-搜索页',
        titleColor: {// 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/drugAndFoodTabooDetail',
      name: 'drugAndFoodTabooDetail',
      component: () => import('@/pages/medicaAssistant/drugAndFoodTaboo/drugAndFoodTabooDetail'),
      meta: {
        title: '药食禁忌',
        buriedTitle: '药食禁忌-详情页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/drugCombination',
      name: 'drugCombination',
      component: () => import('@/pages/medicaAssistant/drugCombination/drugCombination'),
      meta: {
        title: '药物联用',
        buriedTitle: '药物联用-首页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/drugCombinationList',
      name: 'drugCombinationList',
      component: () => import('@/pages/medicaAssistant/drugCombination/drugCombinationList'),
      meta: {
        title: '药物联用-审查结果',
        buriedTitle: '药物联用-审查结果页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/drugCombinationDetail',
      name: 'drugCombinationDetail',
      component: () => import('@/pages/medicaAssistant/drugCombination/drugCombinationDetail'),
      meta: {
        title: '药物联用',
        buriedTitle: '药物联用-详情页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/medicaCalculation',
      name: 'medicaCalculation',
      component: () => import('@/pages/medicaAssistant/medicaCalculation/medicaCalculation'),
      meta: {
        title: '用药计算',
        buriedTitle: '用药计算-首页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        showRightBtn: true,
        rightBtnTxt: '收藏'
      }
    },
    {
      path: '/medicaCalculationDetail',
      name: 'medicaCalculationDetail',
      component: () => import('@/pages/medicalFormula/formulaDetail'),
      meta: {
        title: '用药计算',
        buriedTitle: '用药计算-详情页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
        // showRightBtn: true,
        // rightBtnTxt: '收藏'
      }
    },
    {
      path: '/searchList',
      name: 'searchList',
      component: () => import('@/pages/clinicalGuide/searchList'),
      meta: {
        title: '临床指南-搜索结果',
        buriedTitle: '临床指南-搜索结果',
        titleColor: {// 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/clinicalGuideDetail',
      name: 'clinicalGuideDetail',
      component: () => import('@/pages/clinicalGuide/clinicalGuideDetail'),
      meta: {
        title: '临床指南',
        buriedTitle: '临床指南-详情页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
        // showRightBtn: true,
        // rightBtnTxt: '收藏'
      }
    },
    {
      path: '/clinical',
      name: 'Clinical',
      component: () => import('@/pages/clinicalGuide/home'),
      meta: {
        title: '临床指南',
        buriedTitle: '临床指南-首页',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        },
        showRightBtn: true,
        rightBtnTxt: '收藏'
      }
    },
    {
      path: '/imgPreview',
      name: 'imgPreview',
      component: () => import('@/pages/clinicalGuide/imgPreview'),
      meta: {
        title: '临床指南',
        buriedTitle: '临床指南-详情页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/guideInfo',
      name: 'GuideInfo',
      component: () => import('@/pages/guide/guideDetail'),
      meta: {
        title: '临床指南',
        buriedTitle: '临床指南-详情页-新版',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/medicaAssistantHome',
      name: 'medicaAssistantHome',
      component: () => import('@/pages/medicaAssistant/medicaAssistantHome'),
      meta: {
        title: '用药百科',
        buriedTitle: '用药百科',
        titleColor: {// 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        },
        showRightBtn: true,
        rightBtnTxt: '收藏'
      }
    },
    {
      path: '/medicaAssistantSearch',
      name: 'medicaAssistantSearch',
      component: () => import('@/pages/medicaAssistant/medicaAssistantSearch'),
      meta: {
        title: '用药百科-搜索结果',
        buriedTitle: '用药百科-搜索结果',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/drugClassification',
      name: 'drugClassification',
      component: () => import('@/pages/medicaAssistant/medicaltionReference/drugClassification'),
      meta: {
        title: '西药/基于ATC编码分类',
        buriedTitle: '西药/基于ATC编码分类',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/drugClassificationLevel2',
      name: 'drugClassificationLevel2',
      component: () => import('@/pages/medicaAssistant/medicaltionReference/drugClassificationLevel2'),
      meta: {
        title: '西药/基于ATC编码分类',
        buriedTitle: '西药/基于ATC编码分类',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/drugClassificationLevel3',
      name: 'drugClassificationLevel3',
      component: () => import('@/pages/medicaAssistant/medicaltionReference/drugClassificationLevel3'),
      meta: {
        title: '西药/基于ATC编码分类',
        buriedTitle: '西药/基于ATC编码分类',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/drugClassificationDetails',
      name: 'drugClassificationDetails',
      component: () => import('@/pages/medicaAssistant/medicaltionReference/drugClassificationDetails'),
      meta: {
        title: '药品说明书',
        buriedTitle: '药品说明书',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
        // showRightBtn: true,
        // rightBtnTxt: '收藏'
      }
    },
    {
      path: '/drugInstructions',
      name: 'DrugInstructions',
      component: () => import('@/pages/medicaAssistant/share/drugInstructions'),
      meta: {
        title: '药品说明书',
        buriedTitle: '药品说明书',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
        // showRightBtn: true,
        // rightBtnTxt: '收藏'
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/pages/home/index'),
      meta: {
        title: '医学工具',
        buriedTitle: '医学工具',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        },
        showRightBtn: true,
        rightBtnTxt: '收藏'
      }
    },
    {
      path: '/collection',
      name: 'Collection',
      component: () => import('@/pages/myCollection/index'),
      meta: {
        title: '我的收藏',
        buriedTitle: '我的收藏',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        },
        showRightBtn: true,
        rightBtnTxt: '编辑'
      }
    },
    {
      path: '/toolSearch',
      name: 'ToolSearch',
      component: () => import('@/pages/home/search'),
      meta: {
        title: '医学工具 - 搜索',
        buriedTitle: '医学工具 - 搜索',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/searchFeedback',
      name: 'SearchFeedback',
      component: () => import('@/pages/home/searchFeedback'),
      meta: {
        title: '搜索反馈',
        buriedTitle: '搜索反馈',
        titleColor: {// 标题文案颜色
          red: 0,
          green: 0,
          blue: 0,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/toolSearchResult',
      name: 'ToolSearchResult',
      component: () => import('@/pages/home/searchResult'),
      meta: {
        title: '医学工具 - 搜索结果',
        buriedTitle: '医学工具 - 搜索结果',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/uploadDrugInstructionsList',
      name: 'uploadDrugInstructionsList',
      component: () => import('@/pages/drugInstructions/uploadList'),
      meta: {
        title: '上传说明书赚医米',
        buriedTitle: '上传说明书赚医米',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        showRightBtn: true
      }
    },
    {
      path: '/uploadListSearch',
      name: 'uploadListSearch',
      component: () => import('@/pages/drugInstructions/uploadListSearch'),
      meta: {
        title: '上传说明书赚医米',
        buriedTitle: '上传说明书赚医米-搜索',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        showRightBtn: true
      }
    },
    {
      path: '/uploadDetail',
      name: 'uploadDetail',
      component: () => import('@/pages/drugInstructions/uploadDetail'),
      meta: {
        title: '上传说明书',
        buriedTitle: '上传说明书-详情页',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/regulatoryNotes',
      name: 'regulatoryNotes',
      component: () => import('@/pages/agreement/regulatoryNotes'),
      meta: {
        title: '监管说明书',
        buriedTitle: '监管说明书',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/lactmedInfo',
      name: 'lactmedInfo',
      component: () => import('@/pages/medicaAssistant/drug/lactmedInfo'),
      meta: {
        title: '哺乳等级',
        buriedTitle: '哺乳等级',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/pregnancyInfo',
      name: 'pregnancyInfo',
      component: () => import('@/pages/medicaAssistant/drug/pregnancyInfo'),
      meta: {
        title: '妊娠等级',
        buriedTitle: '妊娠等级',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/newMedicalFormulaHome',
      name: 'NewMedicalFormulaHome',
      component: () => import('@/pages/newMedicalFormula/home'),
      meta: {
        title: '医学公式',
        buriedTitle: '医学公式',
        titleColor: {// 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/newdrug',
      name: 'newdrug',
      component: () => import('@/pages/newdrug/newmedicaAssistantHome'),
      meta: {
        title: '新药',
        buriedTitle: '新药',
        isBack: false,
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 222,
          green: 84,
          blue: 86,
          alpha: 1
        }
      }
    },
    {
      path: '/secDrugClassificationList',
      name: 'SecDrugClassificationList',
      component: () => import('@/pages/newMedicalFormula/secDrugClassificationList'),
      meta: {
        title: '医学公式',
        buriedTitle: '医学公式',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/searchDetail',
      name: 'searchDetail',
      component: () => import('@/pages/newdrug/medicaltionReference/searchdetail'),
      meta: {
        title: '搜索',
        buriedTitle: '搜索',
        titleColor: {// 标题文案颜色
          red: 51,
          green: 51,
          blue: 51,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    },
    {
      path: '/newmedicaAssistantdetail',
      name: 'newmedicaAssistantdetail',
      component: () => import('@/pages/newdrug/newmedicaAssistantdetail'),
      meta: {
        title: '药品说明书',
        buriedTitle: '药品说明书',
        titleColor: { // 标题文案颜色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        },
        titleBg: { // 标题背景色
          red: 255,
          green: 255,
          blue: 255,
          alpha: 1
        }
      }
    }

  ]
  return router
}
// 基础路由
function baseRouter () {
  // 基础router
  const router = [
    // {
    //   path: '/demo',
    //   name: 'demo',
    //   component: () => import('@/pages/demo')
    // }
  ]
  return router
}

// router对象工厂
function routerFactory () {
  let routers = baseRouter()
  // console.log(process.env, '-----------');
  let custormRouters
  console.log(process.env.YSZ_ACTIVITY_NAME)
  let processInfo = process.env
  switch (processInfo.YSZ_ACTIVITY_NAME) {
    case 'YXGJ':
      custormRouters = YXGJRouter()
      break
    default:
      break
  }
  // 合并两个数组
  if (custormRouters) {
    routers = routers.concat(custormRouters)
  }
  const routerObj = new Router({ routes: routers })
  routerObj.beforeEach((to, from, next) => {
    console.log(to)
    console.log(1111, 'router.js')
    console.log(process.env, 'router.js process.env')
    let urlUid = encode.decodeFuc(decodeURIComponent(getUrlParam('uid')))
    console.log(urlUid, 'urlUid')
    console.log(store.state.notNeedLogin)
    console.log(store.state.isApp, 'store.state.isApp')
    if (!store.state.notNeedLogin) { // 需要登陆
      console.log('需要登录')
      console.log(store.state.user.uid)
      if (store.state.user.uid && store.state.user.uid != -1 && store.state.user.uid != 0) {
        console.log('已经有uid了')
        next()
      } else {
        console.log('没有uid，重新调用APP的用户信息')
        if (store.state.isApp && !store.state.isWeChat) { // APP内部 去除微信环境 --- APP进入的用户都是登陆过的用户
          console.log('在APP内部')
          if (store.state.system == 'ios') {
            console.log(new Date().getTime(), 'ios起始调用时间')
            getAppBaseInfo() //
            console.log('调用APP的方法  -- ios')
            AppBaseInfoSave(iosUserInfoCacllBackNotNeedLogin, next)
            store.state.platform = 'iOS'
            // next()
          } else if (store.state.system == 'android') {
            let userInfo = {}
            userInfo.uid = getUidAndroid()
            userInfo.session = getSession()
            userInfo.guid = getGUID()
            userInfo.version = getVersion()
            store.state.platform = 'Android'
            store.commit('setBaseInfo', userInfo)
            storageByCode('uid', String(userInfo.uid))
            storageByCode('session', userInfo.session)
            storageByCode('uuid', userInfo.guid)
            sa.login((userInfo.uid && userInfo.uid != -1) ? String(userInfo.uid) : sa.store.getDistinctId())
            console.log(userInfo, '调用的android APP的方法')
            if (!userInfo.uid) {
              // toLogin()
              // next(false)
              next() // 点击按钮的时候才校验
            } else {
              next()
            }
          }
        } else { // app 外部 ， 不用区分微信
          // 从缓存里面去取用户信息，有就用，没有就去登陆
          let userInfo = {}
          userInfo.uid = storageByCode('uid')
          userInfo.session = storageByCode('session')
          userInfo.guid = storageByCode('guid')
          userInfo.version = storageByCode('version')
          store.commit('setBaseInfo', userInfo)
          checkSession()
            .then(res => {
              sa.login((store.state.user.uid && store.state.user.uid != -1) ? store.state.user.uid : sa.store.getDistinctId())
              next()
            })
            .catch(res => {
              if (res.code === 999) {
                storageByCode('from', window.location.href)
                window.location.replace(window.web_Url + '/testLogin/build/index.html?loginEntrance=medicalTools')
              } else {
                Vue.prototype.toast(res.msg, 'error')
              }
            })
        }
      }
    } else { // 不需要登陆
      // 判断缓存里面是否有uid，有的话就用，没有的话就用-1
      toGetUser(next)
    }
  })

  return routerObj
}
/** ios  回调的函数 APP需要登陆的 */
function iosUserInfoCacllBack (obj, cb) {
  console.log(obj)
  console.log(new Date().getTime(), 'ios 返回时间')
  let iosCallbackInfo = decodeURIComponent(obj)
  let localInfo = JSON.parse(encode.decodeFuc(iosCallbackInfo))
  console.log(localInfo, 'ios 回调的用户信息')
  if (localInfo.uid != store.state.user.uid && localInfo.uid != -1 && localInfo.uid != 0) {
    store.commit('setBaseInfo', localInfo)
    console.log(store.state.user.uid)
    console.log('拿到了APP的用户信息111')
    cb()
  } else {
    console.log('拿到了APP的用户信息,但是用户没有登陆')
    toLogin()
    loginCallBack(closeView)
    appAppWillAppearOrDisappear_ios(closeView)
    // cb()
  }
}

/** ios  回调的函数 APP不需要登陆的 */
function iosUserInfoCacllBackNotNeedLogin (obj, cb) {
  console.log(obj)
  console.log(new Date().getTime(), 'ios 返回时间')
  let iosCallbackInfo = decodeURIComponent(obj)
  let localInfo = JSON.parse(encode.decodeFuc(iosCallbackInfo))
  console.log(localInfo, 'ios 回调的用户信息')
  if (localInfo.uid != store.state.user.uid && localInfo.uid != -1 && localInfo.uid != 0) {
    store.commit('setBaseInfo', localInfo)
    storageByCode('uid', String(localInfo.uid))
    storageByCode('session', localInfo.session)
    storageByCode('uuid', localInfo.guid)
    sa.login((localInfo.uid && localInfo.uid != -1) ? String(localInfo.uid) : sa.store.getDistinctId())
    console.log(store.state.user.uid)
    console.log('拿到了APP的用户信息并且登陆了')
    cb()
  } else {
    console.log('拿到了APP的用户信息,但是用户没有登陆')
    cb()
  }
}

/** 拿APP的用户信息判断 */
function toGetUser (cb) {
  if (store.state.isApp && !store.state.isWeChat) { // APP内部 要去拿APP的用户信息，拿到就提交用户信息，没有就过
    console.log('在APP内部')
    if (store.state.system == 'ios') {
      console.log(new Date().getTime(), 'ios起始调用时间')
      getAppBaseInfo() //
      console.log('调用APP的方法  -- ios')
      AppBaseInfoSave(iosUserInfoCacllBackNotNeedLogin, cb)
      store.state.platform = 'iOS'
    } else if (store.state.system == 'android') {
      let userInfo = {}
      userInfo.uid = getUidAndroid()
      userInfo.session = getSession()
      userInfo.guid = getGUID()
      userInfo.version = getVersion()
      store.state.platform = 'Android'
      store.commit('setBaseInfo', userInfo)
      console.log(userInfo, '调用的android APP的方法')
      cb()
    }
  } else { // app 外部 ， 不用区分微信
    // 从缓存里面去取用户信息，有就用，没有就去登陆
    let userInfo = {}
    let uidS = storageByCode('uid')
    let sessionS = storageByCode('session')
    userInfo.uid = uidS || -1
    userInfo.session = sessionS || ''
    userInfo.guid = storageByCode('uuid')
    userInfo.version = storageByCode('version')
    store.commit('setBaseInfo', userInfo)
    sa.login((store.state.user.uid && store.state.user.uid != -1) ? store.state.user.uid : sa.store.getDistinctId())
    cb()
  }
}

export default routerFactory()



// WEBPACK FOOTER //
// ./src/router/index.js